
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-resources/references",
      function () {
        return require("private-next-pages/metal-resources/references/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-resources/references"])
      });
    }
  